export default __webpack_public_path__ + "static/media/EAS_SNHL_IND_01.812309fe.jpg";